<template>
    <form class="row" @submit.prevent="updateAppID">
        <div class="col-12 col-md-12">
            <label class="akkurate-dark small" for="saving_id">Select Product<star></star></label>
            <b-form-group id="saving_id" label-for="saving_id">
                <multiselect id="saving_id" name="saving_id" class="mt-2 field-container" v-model="saving_id"
                    :options="account_options" track-by="id" label="saving_id" :custom-label="customLabel">
                </multiselect>
                <errors v-if="errors_msg.saving_id">
                    {{ errors_msg.saving_id[0] }}
                </errors>
            </b-form-group>
        </div>
        <hr class="mt-4" />
        <div class="col-12 text-end">
            <button type="submit" :disabled="isSaving" class="btn akkurate-green-btn text-white btn-size me-3">
                <span class="small">
                    <font-awesome-icon class="me-2" :icon="['fas', 'save']" />Update
                </span>
            </button>
        </div>
    </form>
</template>

<script>
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";

export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            isLoading: false,
            errors_msg: {},
            account_options: [],
            isSaving: false,
            saving_id: "",
        }
    },
    props: {
        customer_id: {
            required: true
        },
        loan_no: {
            required: true
        }
    },
    mounted() {
        console.log(this.customer_id);
        console.log(this.loan_no);
        this.getSavingSharesAccountDropdown();
    },
    methods: {
        async getSavingSharesAccountDropdown() {
            await ApiService.get(`/accounts/member/saving-shares/${this.customer_id}/dropdown`)
                .then((response) => {
                    console.log(response.data.accounts);
                    this.account_options = response.data.accounts;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        customLabel({ account_type, account_balance }) {
            return `${account_type?.name} - (${this.displayNumber(account_balance)})`
        },
        async updateAppID() {
            this.isSaving = true;
            let form = {
                'loan_number': this.loan_no,
                'application_account_id': this.saving_id.id
            }
            ApiService.post("/loans/update/saving-application", form)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.save = "Save";
                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    this.errors_msg = {};
                    this.$emit('updatedAccount', this.loan_no);
                    // this.form = this.initialState().form;
                })
                .catch((error) => {
                    // console.log(error.response.data.message);
                    this.isSaving = false;
                    this.$Progress.fail();
                    this.save = "Save";
                    if (error.response.data) {
                        // Clear previous errors
                        this.errors_msg = {};
                        // Set general message
                        this.errors_msg.message = error.response.data.message;
                        // Set field-specific errors if they exist
                        if (error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach(key => {
                                this.errors_msg[key] = error.response.data.errors[key];
                            });
                        }
                    }
                });

        }

        //  getDisabled(){
        //     if(this.form.model_id == ""){
        //         return false
        //     }else{
        //         return true
        //     }
        // },
        // coaSelectLabel({ id, name, code, coabranch }) {
        //     let select_label = `${code ? code : ""} - ${name}`
        //     if (coabranch) {
        //         select_label += `- ${coabranch.name}`
        //     }
        //     return select_label;
        // },

    }

}
</script>